.Tabs {
  width: 100%;
}

/* Mobile fallback: a SingleSelect rendered alongside the tabs.
   Hidden on desktop; takes over below the md breakpoint so horizontal
   tab rows never produce lateral page scroll on narrow viewports. */
.MobileSelect {
  display: none;
}

/* ---------- Segmented control (.rv-seg) — switching same data view ---------- */
.TabsList {
  align-items: center;
  align-self: flex-start;
  background: var(--rv-bg-app-preview);
  border: 1px solid var(--rv-border);
  border-radius: var(--rv-radius-md);
  color: var(--rv-fg-3);
  display: inline-flex;
  gap: var(--space-xxs);
  justify-content: center;
  padding: var(--space-xxs);
  transition: background-color var(--rv-dur-fast) var(--rv-ease-out);

  &.rounded {
    border-radius: var(--rv-radius-full);
  }

  &.fill {
    width: 100%;
  }
}

.TabsTrigger {
  align-items: center;
  background: transparent;
  border: 1px solid transparent;
  border-radius: var(--rv-radius-sm);
  color: var(--rv-fg-3);
  cursor: pointer;
  display: inline-flex;
  font-family: var(--rv-font-ui);
  font-size: var(--rv-text-xs);
  font-weight: var(--rv-w-medium);
  gap: var(--rv-space-1);
  justify-content: center;
  padding: var(--rv-space-1) var(--rv-space-3);
  transition:
    background-color var(--rv-dur-fast) var(--rv-ease-out),
    color var(--rv-dur-fast) var(--rv-ease-out),
    box-shadow var(--rv-dur-fast) var(--rv-ease-out);
  white-space: nowrap;

  &.rounded {
    border-radius: var(--rv-radius-full);
  }

  &.fill {
    flex: 1;
  }
}

.TabsTrigger:hover:not(.disabled, .active) {
  background: var(--rv-surface);
  color: var(--rv-fg-1);
}

.TabsTrigger.active {
  background: var(--rv-surface);
  border-color: var(--rv-border);
  box-shadow: var(--rv-shadow-sm);
  color: var(--rv-fg-1);
}

.TabsTrigger.disabled {
  cursor: not-allowed;
  opacity: 50%;
  pointer-events: none;
}

/* ---------- Underline tabs (.rv-tabs) — primary nav within a page ---------- */
.TabsList.underline {
  background: transparent;
  border: none;
  border-bottom: 1px solid var(--rv-border);
  border-radius: 0;
  display: flex;
  gap: var(--space-xxs);
  overflow-x: auto;
  padding: 0;
  scrollbar-width: none;
  width: 100%;
}

.TabsList.underline.wrap {
  flex-wrap: wrap;
  overflow-x: visible;
}

.TabsList.underline::-webkit-scrollbar {
  display: none;
}

.TabsList.underline .TabsTrigger {
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  border-radius: 0;
  color: var(--rv-fg-3);
  font-size: var(--rv-text-sm);
  margin-bottom: -1px;
  padding: var(--rv-space-2) var(--rv-space-3) var(--rv-space-3);
}

.TabsList.underline .TabsTrigger:hover:not(.disabled, .active) {
  background: transparent;
  color: var(--rv-fg-1);
}

.TabsList.underline .TabsTrigger.active {
  background: transparent;
  border-bottom-color: var(--rv-accent);
  box-shadow: none;
  color: var(--rv-fg-1);
}

@media (--max-md) {
  .TabsList,
  .TabsList.underline {
    display: none;
  }

  .MobileSelect {
    display: block;
  }
}
